import React from "react";

export const TripDetailContext = React.createContext(null);

export const useTripDetailContext = () => {
  const context = React.useContext(TripDetailContext);

  if (!context) throw new Error("Trip Detail Context not provided!");

  return context;
};